import { Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { FilterNGraphEchartService } from 'src/app/services/filters-n-graph-echarts/filter-n-graph-echart.service';
import { PreselectionDatePickerType } from 'src/app/tinea-components/dateTime-picker/component/enums/preselection-date-picker-type';

@Component({
    selector: 'app-filters-n-graph-echart',
    templateUrl: './filters-n-graph-echart.component.html',
    styleUrls: ['./filters-n-graph-echart.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FiltersNGraphEchartComponent implements OnInit {

  @Input() eUid: string;
  @Input() graphID: string;
  @Input() configuredPreselectionId: PreselectionDatePickerType = PreselectionDatePickerType.LASTWEEK;
  @Input() graphChoicesStepEnabled = false;

  @Input() isRequesting: boolean;
  @Input() selectedTagsUid: Array<any> ;

  constructor(public componentService: FilterNGraphEchartService) { }

  ngOnInit(): void {
  } 
}
